module.exports = __webpack_public_path__ + "static/media/boshilun1.c76c8edc.png";